import { SearchContext } from 'components/search/SearchContext';
import { SearchResultsPage } from 'components/search/SearchResultsPage';

export const GroupSearchResults = () => {
  return (
    <SearchContext locale="en-US" type="group">
      <SearchResultsPage />
    </SearchContext>
  );
};
